module.exports = __webpack_public_path__ + "media/images/flags/16/Iran-7d5492ba3dbbc1f0e43fdb022b51ec9a.png";